import { useNavigate } from 'react-router-dom'

import { Alert } from '@/components/ui/Alert'
import { Button } from '@/components/ui/Button'
import { Card, CardBody, CardHeader } from '@/components/ui/Card'

const DEFAULT_MESSAGE = '해당 구장의 관리자가 아닙니다.'

/**
 * 미연결 구장 접근 안내 — **403 공통 처리** (설계 §2-1(e), #584 §2·§4).
 *
 * 🚨 **재시도 버튼을 주지 않는다.** 403 은 토큰 재발급·재시도 대상이 아니다(권한이 없는 것이지
 * 일시적 실패가 아니다). 사용자가 할 수 있는 유일한 행동은 **관리 중인 구장으로 돌아가는 것**이다.
 *
 * 🚨 존재(404)와 권한(403)을 뭉개지 않는다 — 없는 구장은 기존 `ErrorState` 가 처리한다.
 */
export function VenueForbiddenNotice({ message }: { message?: string }) {
  const navigate = useNavigate()

  return (
    <Card>
      <CardHeader title="이 구장의 관리 권한이 없습니다" />
      <CardBody className="space-y-4">
        <Alert tone="danger" title="접근할 수 없는 구장입니다">
          {/* 서버가 준 문구를 그대로 보여준다 — 사유는 서버가 가장 정확히 안다. */}
          {message?.trim() || DEFAULT_MESSAGE}
        </Alert>
        <Button
          onClick={() => {
            navigate('/venues/select', { replace: true })
          }}
        >
          관리 중인 구장 선택
        </Button>
      </CardBody>
    </Card>
  )
}
